(function(){
function initSbc(root){
var formEl = root.querySelector('[data-sbc-form]');
if(formEl){ formEl.addEventListener('submit', function(e){ e.preventDefault(); }); }
var variants = JSON.parse(root.querySelector('[data-variants]').textContent);
var finishes = [];
variants.forEach(function(v){ if(finishes.indexOf(v.finish)<0) finishes.push(v.finish); });
var orderF = ['Digital Design','Poster','Canvas','Framed Canvas'];
finishes.sort(function(a,b){ return orderF.indexOf(a)-orderF.indexOf(b); });
var finishImg = {
"Digital Design":"https://cdn.shopify.com/s/files/1/0597/8914/8344/files/nf_digital.jpg?v=1782571859&width=200",
"Poster":"https://cdn.shopify.com/s/files/1/0597/8914/8344/files/nf_poster.jpg?v=1782571859&width=200",
"Canvas":"https://cdn.shopify.com/s/files/1/0597/8914/8344/files/nf_canvas.jpg?v=1782571859&width=200",
"Framed Canvas":"https://cdn.shopify.com/s/files/1/0597/8914/8344/files/nf_framed.jpg?v=1782571859&width=200"
};
var sizeImg = {
"8\" x 10\"":"https://cdn.shopify.com/s/files/1/0597/8914/8344/files/size_8x10_4ccac4b1-4567-4dca-afe3-98fbe549d0aa.png?v=1782422634&width=200",
"12\" x 16\"":"https://cdn.shopify.com/s/files/1/0597/8914/8344/files/size_12x16_dababcd6-51c5-4651-af27-6653dd3f333c.png?v=1782422633&width=200",
"18\" x 24\"":"https://cdn.shopify.com/s/files/1/0597/8914/8344/files/size_18x24_231b711b-3878-418f-bbee-ec38ea7a31cc.png?v=1782422637&width=200",
"24\" x 30\"":"https://cdn.shopify.com/s/files/1/0597/8914/8344/files/size_24x30_48140211-519f-4887-9d56-c82c9337ad64.png?v=1782422633&width=200",
"30\" x 40\"":"https://cdn.shopify.com/s/files/1/0597/8914/8344/files/size_30x40_b839ebec-47c5-494d-a674-8774411a06d4.png?v=1782422634&width=200"
};
function headNum(h){ var m=(h||'').match(/\d+/); return m?parseInt(m[0],10):0; }
var state = { finish:null, heads:null, size:null, step:0 };
var steps = root.querySelectorAll('.sbc-step');
var total = steps.length;
var nodes = root.querySelectorAll('[data-nodes] .sbc-node');
var elPrice = root.querySelector('[data-price]');
var elCompare = root.querySelector('[data-compare]');
var elSave = root.querySelector('[data-save]');
var elErr = root.querySelector('[data-err]');
var btnNext = root.querySelector('[data-next]');
var btnBack = root.querySelector('[data-back]');
var btnAdd = root.querySelector('[data-add]');
var modal = root.querySelector('[data-modal]');
function money(c){ return '$' + (c/100).toFixed(2); }
function minP(f,h,s){ var m=null; variants.forEach(function(v){ if(f!=null&&v.finish!==f)return; if(h!=null&&v.heads!==h)return; if(s!=null&&v.size!==s)return; if(m===null||v.price<m)m=v.price; }); return m; }
function priceFrom(f){ return minP(f,null,null); }
function curVariant(){ return variants.filter(function(v){ return v.finish===state.finish && v.heads===state.heads && v.size===state.size; })[0]; }
function selectedAddons(){ return Array.prototype.slice.call(root.querySelectorAll('[data-addon]')).filter(function(a){ return a.querySelector('input').checked; }); }
var fWrap = root.querySelector('[data-finish-opts]');
var hWrap = root.querySelector('[data-heads-opts]');
var sWrap = root.querySelector('[data-size-opts]');
finishes.forEach(function(f){
var b=document.createElement('button'); b.type='button'; b.className='sbc-opt sbc-fopt'; b.setAttribute('data-finish', f);
var img = finishImg[f] ? '<img src="'+finishImg[f]+'" alt="'+f+'" loading="lazy">' : '';
b.innerHTML = img + '<span class="lab">'+f.replace(' Design','')+'</span><span class="pr">from '+money(priceFrom(f))+'</span>';
b.addEventListener('click', function(){ state.finish=f; state.heads=null; state.size=null; buildHeads(); sWrap.innerHTML=''; markSel(fWrap,b); updatePrice(); clearErr(); });
fWrap.appendChild(b);
});
function buildHeads(){
hWrap.innerHTML='';
var seen=[];
variants.filter(function(v){ return v.finish===state.finish; }).forEach(function(v){ if(seen.indexOf(v.heads)<0) seen.push(v.heads); });
seen.sort(function(a,b){ return headNum(a)-headNum(b); });
seen.forEach(function(h){
var b=document.createElement('button'); b.type='button'; b.className='sbc-opt'; b.setAttribute('data-heads', h);
b.innerHTML = '<span class="lab">'+h+'</span><span class="pr">from '+money(minP(state.finish,h,null))+'</span>';
b.addEventListener('click', function(){ state.heads=h; state.size=null; buildSizes(); markSel(hWrap,b); updatePrice(); clearErr(); });
hWrap.appendChild(b);
});
}
function buildSizes(){
sWrap.innerHTML='';
variants.filter(function(v){ return v.finish===state.finish && v.heads===state.heads; }).forEach(function(v){
var b=document.createElement('button'); b.type='button'; b.className='sbc-opt sbc-fopt'; b.setAttribute('data-size', v.size);
var img = sizeImg[v.size] ? '<img src="'+sizeImg[v.size]+'" alt="'+v.size+'" loading="lazy">' : '';
b.innerHTML = img + '<span class="lab">'+v.size+'</span><span class="pr">'+money(v.price)+'</span>';
b.addEventListener('click', function(){ state.size=v.size; markSel(sWrap,b); updatePrice(); clearErr(); });
sWrap.appendChild(b);
});
}
function markSel(wrap, el){ wrap.querySelectorAll('.sbc-opt').forEach(function(x){ x.classList.remove('is-sel'); }); el.classList.add('is-sel'); }
root.querySelectorAll('[data-addon]').forEach(function(a){
a.querySelector('input').addEventListener('change', function(){ a.classList.toggle('is-sel', this.checked); updatePrice(); });
});
function pulse(){ elPrice.classList.remove('pulse'); void elPrice.offsetWidth; elPrice.classList.add('pulse'); }
function updatePrice(){
var v=curVariant();
var base = v ? v.price : (state.finish ? minP(state.finish, state.heads, state.size) : null);
if(base===null){ elPrice.textContent='—'; elCompare.textContent=''; elSave.hidden=true; }
else {
var addc=0; selectedAddons().forEach(function(a){ addc+=parseInt(a.dataset.price,10); });
elPrice.textContent=money(base+addc); pulse();
if(v && v.compare>v.price){ elCompare.textContent=money(v.compare); elSave.hidden=false; elSave.textContent='Save '+money(v.compare-v.price); }
else { elCompare.textContent=''; elSave.hidden=true; }
}
root.querySelector('[data-sum-finish]').textContent = state.finish ? state.finish.replace(' Design','') : '—';
var sh=root.querySelector('[data-sum-heads]'); if(sh) sh.textContent = state.heads || '—';
root.querySelector('[data-sum-size]').textContent = state.size || '—';
var ads=selectedAddons().map(function(a){ return a.querySelector('.ad-t').textContent.replace(/^[^A-Za-z]+/,''); });
var aw=root.querySelector('[data-sum-addons-wrap]');
if(ads.length){ aw.hidden=false; root.querySelector('[data-sum-addons]').textContent=ads.join(', '); } else { aw.hidden=true; }
if(v){ var t=v.price; selectedAddons().forEach(function(a){ t+=parseInt(a.dataset.price,10); }); root.querySelector('[data-sum-total]').textContent=money(t); }
else { root.querySelector('[data-sum-total]').textContent='—'; }
}
function showStep(i){
state.step=i;
steps.forEach(function(s,idx){ s.classList.toggle('is-active', idx===i); });
root.querySelector('[data-fill]').style.width = (total>1 ? (i/(total-1)*100) : 100)+'%';
nodes.forEach(function(n,idx){
n.classList.toggle('done', idx<i);
n.classList.toggle('current', idx===i);
n.innerHTML = idx<i ? '✓' : (idx+1);
});
root.querySelector('[data-stepno]').textContent = 'Step '+(i+1);
root.querySelector('[data-stepname]').textContent = steps[i].getAttribute('data-name');
btnBack.hidden = i===0;
var last = i===total-1;
btnNext.hidden = last;
btnAdd.hidden = !last;
clearErr();
}
function clearErr(){ elErr.style.display='none'; }
function showErr(m){ elErr.textContent=m; elErr.style.display='block'; }
function photoUploaded(){
var up = root.querySelector('[data-upload]');
if(!up) return true;
var fi = up.querySelectorAll('input[type=file]');
for(var i=0;i<fi.length;i++){ if(fi[i].files && fi[i].files.length>0) return true; }
var pi = up.querySelectorAll('[name^="properties["]');
for(var j=0;j<pi.length;j++){ if(pi[j].hasAttribute('data-photo')) continue; if(pi[j].value && pi[j].value.trim()!=='') return true; }
return false;
}
btnNext.addEventListener('click', function(){
var cur=steps[state.step]; var req=cur.getAttribute('data-required');
if(req==='finish' && !state.finish){ showErr('Please choose a finish to continue.'); return; }
if(req==='heads' && !state.heads){ showErr('Please choose how many pets or people.'); return; }
if(req==='size' && !state.size){ showErr('Please choose a size to continue.'); return; }
if(cur.hasAttribute('data-upload') && !photoUploaded()){ modal.hidden=false; return; }
showStep(Math.min(state.step+1, total-1));
});
btnBack.addEventListener('click', function(){ showStep(Math.max(state.step-1, 0)); });
root.querySelector('[data-modal-upload]').addEventListener('click', function(){ modal.hidden=true; });
root.querySelector('[data-modal-later]').addEventListener('click', function(){
var ph=root.querySelector('[data-photo]'); if(ph) ph.value='Will send by email after checkout';
var pw=root.querySelector('[data-sum-photo-wrap]'); if(pw){ pw.hidden=false; root.querySelector('[data-sum-photo]').textContent='Sending later by email'; }
modal.hidden=true; showStep(Math.min(state.step+1, total-1));
});
modal.addEventListener('click', function(e){ if(e.target===modal) modal.hidden=true; });
var mugBtn = root.querySelector('[data-mug-info]');
var mugModal = root.querySelector('[data-mug-modal]');
if(mugBtn && mugModal){
mugBtn.addEventListener('click', function(e){ e.preventDefault(); e.stopPropagation(); mugModal.hidden=false; });
mugModal.addEventListener('click', function(e){ if(e.target===mugModal || e.target.hasAttribute('data-mug-close')) mugModal.hidden=true; });
document.addEventListener('keydown', function(e){ if(e.key==='Escape') mugModal.hidden=true; });
}
var mainImg=root.querySelector('.sbc-main');
root.querySelectorAll('.sbc-thumb').forEach(function(t){
t.addEventListener('click', function(){ mainImg.src=t.dataset.src; root.querySelectorAll('.sbc-thumb').forEach(function(x){ x.classList.remove('is-active'); }); t.classList.add('is-active'); });
});
btnAdd.addEventListener('click', function(){
var v=curVariant();
if(!v){ showErr('Please choose finish, pets and size first.'); showStep(0); return; }
var props={};
root.querySelectorAll('[name^="properties["]').forEach(function(inp){
var key=inp.name.replace('properties[','').replace(']','');
if(inp.value && inp.value.trim()!=='') props[key]=inp.value.trim();
});
var items=[{ id:v.id, quantity:1, properties:props }];
selectedAddons().forEach(function(a){ items.push({ id:parseInt(a.dataset.variant,10), quantity:1 }); });
btnAdd.disabled=true; btnAdd.textContent='Adding…';
fetch('/cart/add.js', { method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({items:items}) })
.then(function(r){ if(!r.ok) return r.json().then(function(e){ throw e; }); return r.json(); })
.then(function(){ window.location.href='/cart'; })
.catch(function(e){ btnAdd.disabled=false; btnAdd.textContent='Add to cart 🐾'; showErr((e && e.description) ? e.description : 'Something went wrong. Please try again.'); });
});
if(finishes.length){
state.finish = finishes[0];
buildHeads();
var first = fWrap.querySelector('[data-finish="'+finishes[0]+'"]');
if(first) first.classList.add('is-sel');
}
updatePrice();
showStep(0);
}
function boot(){ document.querySelectorAll('[data-sbc]').forEach(initSbc); }
if(document.readyState!=='loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
})();
